import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	definition_open_chat_user_initial_query: {
		id: 'search_ai.definitions_open_chat_initial_query',
		defaultMessage: 'Define {term}',
		description:
			'A message to be passed to AI chat from definitions, this will be shown as if user has asked the bot to define a term',
	},
});
